import {createContext} from 'react';
import {Account} from '../features/accounts/types';

// The signed-in operator's account record, fetched from console-api by
// src/providers/UserAccountProvider.tsx.
//
// `undefined` is the honest default and means "not loaded yet or not
// available" — it is NOT an empty Account. Consumers must handle it;
// defaulting to `{} as Account` would hand every consumer an object whose
// every field is undefined, turning a missing account into silently blank
// UI instead of a case the component decides how to render.
export type UserAccountContextType = {
    userAccount: Account | undefined;
};

export const UserAccountContext = createContext<UserAccountContextType>({
    userAccount: undefined,
});
